<template>
    <div
        v-if="isLoading"
        id="app-overlay"
        class="p-dialog-mask pointer-events-auto"
    >
        <p-progress-spinner v-if="isLoading" stroke-width="4" />
    </div>
</template>

<script setup lang="ts">
import { useRootStore } from '@/store';
import { computed } from 'vue';

const rootStore = useRootStore();
const isLoading = computed(() => rootStore.getters.isLoading);
</script>

<style scoped lang="scss">
#app-overlay {
    z-index: 9999;
    opacity: 0.46;
    background-color: #eceff1 !important;
    height: 100%;
    width: 100%;
    top: 0;
    position: absolute;
}
</style>